import { Group as AntdGroup } from "@empglabs/backoffice-ui-kit"

const Group = props => {
  return <AntdGroup {...props} />
}

export default Group
